import { api } from "@shared/api/client";
import type { DashboardPlant, FleetOverview, PlantOverview } from "../types";

/** One optional value per fleet header selector; null means "all". */
export interface FleetSelection {
  region: string | null;
  power_plant_id: string | null;
  risk_category: string | null;
  spof_owner: string | null;
}

export const EMPTY_FLEET_SELECTION: FleetSelection = {
  region: null,
  power_plant_id: null,
  risk_category: null,
  spof_owner: null,
};

export async function getFleetOverview(
  selection: FleetSelection,
): Promise<FleetOverview> {
  const { data } = await api.get<FleetOverview>("/dashboard/fleet", {
    params: Object.fromEntries(
      Object.entries(selection).filter(([, value]) => value !== null),
    ),
  });
  return data;
}

export async function getDashboardPlants(): Promise<DashboardPlant[]> {
  const { data } = await api.get<DashboardPlant[]>("/dashboard/plants");
  return data;
}

export async function getPlantOverview(
  plantId: string,
  selection: FleetSelection,
): Promise<PlantOverview> {
  const { data } = await api.get<PlantOverview>(
    `/dashboard/plants/${plantId}/overview`,
    {
      params: {
        ...(selection.risk_category && {
          risk_category: selection.risk_category,
        }),
        ...(selection.spof_owner && {
          spof_owner: selection.spof_owner,
        }),
      },
    },
  );
  return data;
}
